module.exports = __webpack_public_path__ + "static/media/naim.860aaec1.jpg";